import PasswordForm from "../../../routes/csr/change-password/password-form";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

const CHANGE_PASSWORD_POP_UP_OVERLAY_HEIGHT = 1080;
const CHANGE_PASSWORD_POP_UP_WIDTH = 500;
const CHANGE_PASSWORD_POP_UP_PADDING = 24;
const CHANGE_PASSWORD_POP_UP_MAX_HEIGHT_CSS = "90vh";

const ChangePasswordPopUp = withLiteObserverAndTheme<{ width: number }>(
  (props) => {
    const { theme, width } = props;
    const { colors, unitY } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={width}
        height={CHANGE_PASSWORD_POP_UP_OVERLAY_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparentGray}
        style={{
          position: "fixed",
          top: 0,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={true}
          isExtendable={true}
          withShadow={false}
          width={CHANGE_PASSWORD_POP_UP_WIDTH}
          height={0}
          fDirection="column"
          alignItems="center"
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={{
            boxSizing: "border-box",
            position: "relative",
            maxHeight: CHANGE_PASSWORD_POP_UP_MAX_HEIGHT_CSS,
            overflowY: "auto",
            paddingTop: CHANGE_PASSWORD_POP_UP_PADDING * unitY,
            paddingBottom: CHANGE_PASSWORD_POP_UP_PADDING * unitY
          }}
          onClick={() => {}}
        >
          <PasswordForm />
        </ET3Div>
      </ET3Div>
    );
  }
);
export default ChangePasswordPopUp;
